import type { GameState } from "./types";
import { activeVictoryCondition, countOwnedCities, ownsAllMonuments } from "./victory";

function enemyCompletedObjective(
  source: Pick<GameState, "victoryConditions" | "captureCityTarget" | "tiles">,
): boolean {
  const condition = activeVictoryCondition(source);
  if (condition === "capture") {
    const target = source.captureCityTarget ?? 0;
    return target > 0 && countOwnedCities(source.tiles, "p2") >= target;
  }
  if (condition === "monuments") {
    return ownsAllMonuments({ tiles: source.tiles, owner: "p2" });
  }
  return false;
}

export function victorySubtext({
  status,
  dayNumber,
  state,
}: {
  status: "victory" | "defeat";
  dayNumber: number;
  state: Pick<GameState, "victoryConditions" | "captureCityTarget" | "tiles">;
}): string {
  const condition = activeVictoryCondition(state);
  if (status === "defeat") {
    if (condition === "capture" && enemyCompletedObjective(state)) {
      return "The enemy captured enough cities.";
    }
    if (condition === "monuments" && enemyCompletedObjective(state)) {
      return "The enemy captured all monuments.";
    }
    return "Your forces have been wiped out.";
  }
  if (condition === "capture") {
    return `Enough cities captured after ${dayNumber} days.`;
  }
  if (condition === "monuments") {
    return `All monuments captured after ${dayNumber} days.`;
  }
  return `All enemy units eliminated after ${dayNumber} days.`;
}
